import ShowcaseDesc from "./DescriptionShowcase";
import ShowcaseImage from "./ImageShowcase";
import ShowcaseEmbed from "./EmbedShowcase";
import ShowcaseGallery from "./GalleryShowcase";

function ShowcaseProject({
    children,
    Title = 'Unnamed Project',
    Date = 'Today',
    EmbedCode = undefined,
    EmbedSrc = "",
    EmbedLink = "",
    EmbedAuthorText = "",
    ImageURLs = "",
    ImageAlts = "",
    ProjectURL = "",
    ButtonText = "",
    OnLeft = false
    }) {
    if (EmbedSrc !== undefined && EmbedSrc) {
        return (
            <ShowcaseEmbed
              Title={Title}
              Date={Date}
              EmbedSrc={EmbedSrc}
              EmbedLink={EmbedLink}
              EmbedAuthorText={EmbedAuthorText}
              ButtonURL={ProjectURL}
              ButtonText={ButtonText}
              EmbedOnLeft={OnLeft}
            >
                {children}
            </ShowcaseEmbed>
        );
    }
    else if (EmbedCode !== undefined) {
        return (
            <ShowcaseEmbed
              Title={Title}
              Date={Date}
              EmbedCode={EmbedCode}
              ButtonURL={ProjectURL}
              ButtonText={ButtonText}
              EmbedOnLeft={OnLeft}
              >
                {children}
            </ShowcaseEmbed>
        );
    }
    else if (typeof ImageURLs === 'string' && ImageURLs) {
        return (
            <ShowcaseImage
              Title={Title}
              Date={Date}
              ImgURL={ImageURLs}
              ImgAlt={ImageAlts}
              ButtonURL={ProjectURL}
              ButtonText={ButtonText}
              ImageOnLeft={OnLeft}
            >
                {children}
            </ShowcaseImage>
        )
    }
    else if (ImageURLs !== undefined && typeof ImageURLs !== 'string') {
        return (
            <ShowcaseGallery
              Title={Title}
              Date={Date}
              ImgURLs={ImageURLs}
              ImgAlts={ImageAlts}
              ButtonURL={ProjectURL}
              ButtonText={ButtonText}
              ImageOnLeft={OnLeft}
            >
                {children}
            </ShowcaseGallery>
        )
    }
    
    return (
        <ShowcaseDesc
          Title={Title}
          Date={Date}
          ButtonURL={ProjectURL}
          ButtonText={ButtonText}
        >
            {children}
        </ShowcaseDesc>
    );
}

export default ShowcaseProject;